import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import { Link } from '@mui/material';
const Pagination = (props) => {
    const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize, className } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // if (currentPage === 0 || paginationRange.length < 2) {
    //     return null;
    // }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <ul className={classnames('pagination-container', { [className]: className })}>
            <li>
                <Link
                    className={classnames('pagination-item', {
                        disabled: currentPage === 1
                    })}
                    onClick={onPrevious}
                    onKeyDown={onPrevious}
                >
                    <div className="arrow left" />
                </Link>
            </li>
            {paginationRange.map((pageNumber, index) => {
                if (pageNumber === DOTS) {
                    return (
                        <li className="pagination-item dots" key={pageNumber + index}>
                            &#8230;
                        </li>
                    );
                }
                return (
                    <li key={pageNumber}>
                        <Link
                            className={classnames('pagination-item', {
                                selected: pageNumber === currentPage
                            })}
                            onClick={() => onPageChange(pageNumber)}
                            onKeyDown={() => onPageChange(pageNumber)}
                            key={pageNumber}
                        >
                            {pageNumber}
                        </Link>
                    </li>
                );
            })}
            <li>
                <Link
                    className={classnames('pagination-item', {
                        disabled: currentPage === lastPage
                    })}
                    onClick={onNext}
                    onKeyDown={onNext}
                >
                    <div className="arrow right" />
                </Link>
            </li>
        </ul>
    );
};

export default Pagination;
